/**
 * Which product a schema-driven RMS form belongs to, for analytics attribution.
 *
 * HFP forms run on the RMS form machinery but are their own product: every HFP
 * schema key is prefixed 'hfp' across all three generations in use (hfp*,
 * hfpV2*, hfpV3*), and post-account keys can arrive respondent-suffixed
 * (hfpV2Sensory_guardian), so the prefix is the reliable discriminator rather
 * than a key list that would need extending per release. The per-generation
 * lists in referralStatus (HFP_FORM_KEYS, HFP_V3_FORM_KEYS) deliberately are
 * not reused here: each covers one generation only, and neither accounts for
 * the respondent suffix, so a union of them would silently mislabel a form the
 * moment a new generation or role lands.
 *
 * The server-side analytics bridge resolves the same question the same way from
 * the audit trail. Keep the two in step: a form whose client rows and server
 * rows disagree about product splits one journey across two labels, and the
 * funnel milestone events are recorded server-side only.
 */
export function productForRmsFormKey(formKey) {
  const key = typeof formKey === 'string' ? formKey : '';
  return key.startsWith('hfp') ? 'hfp' : 'rms';
}

export default productForRmsFormKey;
